// extracted by mini-css-extract-plugin
export default {"form":"jGKd3vkivstqnYT35OPZ"};